import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field, Form, reduxForm, SubmissionError } from 'redux-form';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Error, FieldFlex, FirstFieldFlex, SuccessMessage } from './styles';
import InputPassword from '../../ui/forms/input-password';
import { Flex, Label, PrimaryButton } from '../../../style';
import { passwordFormat, passwordsMatch, required } from '../../../../../core/legacy/utils/validation';
import { loadConfigFromRootDataset } from '../../../../../config';

const ResetPasswordForm = ({ handleSubmit, error, invalid, submitSucceeded }) => {
    const { t } = useTranslation();

    if (submitSucceeded) {
        return (
            <div>
                <SuccessMessage>{t('reset-password.success')}</SuccessMessage>
                <Link to="/">{t('reset-password.back-to-login')}</Link>
            </div>
        );
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Flex column>
                <FirstFieldFlex>
                    <Label>{t('reset-password.new-password')}</Label>
                    <Field
                        component={InputPassword}
                        name="newPassword"
                        type="password"
                        validate={[required, passwordFormat]}
                        width="400px"
                    />
                </FirstFieldFlex>
                <FieldFlex>
                    <Label>{t('reset-password.confirm-password')}</Label>
                    <Field
                        component={InputPassword}
                        name="confirmPassword"
                        type="password"
                        validate={[required, passwordFormat, passwordsMatch]}
                        width="400px"
                    />
                </FieldFlex>
            </Flex>
            <Flex justify="center" width="400px">
                <PrimaryButton disabled={invalid} type="submit">
                    {t('reset-password.submit')}
                </PrimaryButton>
            </Flex>
            {error && <Error>{t(error)}</Error>}
        </Form>
    );
};

ResetPasswordForm.propTypes = {
    error: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
};

export default reduxForm({
    form: 'reset-password',
    onSubmit: async (values, _dispatch, props) => {
        const { backendUrl } = loadConfigFromRootDataset();
        try {
            await axios.post(`${backendUrl}/auth/reset-password/confirm`, {
                token: props.token,
                newPassword: values.newPassword,
            });
        } catch {
            throw new SubmissionError({ _error: 'reset-password.invalid-link' });
        }
    },
})(ResetPasswordForm);
